import { React, useEffect } from "react";

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="page press">
      <h1>Press</h1>{" "}
      <div className="press-entry">
        <a
          href="https://isthmus.com/events/comedians-of-the-world-telling-jokes-july-3/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks - Comedians of the World Telling Jokes</h2>
        </a>

        <a
          href="https://isthmus.com/events/comedians-of-the-world-telling-jokes-july-3/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>July 3, 2026</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-june-4-to-7-2026/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>What to do in Madison this weekend</h2>
        </a>

        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-june-4-to-7-2026/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>June 4, 2026</em>
      </div>
      <div className="press-entry">
        <a
          href="https://link.citycast.fm/view/64f77e42538bff03dfdd62c5qfv6i.1wt/96b20693"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>The Cat Turns 300!</h2>
        </a>

        <a
          href="https://link.citycast.fm/view/64f77e42538bff03dfdd62c5qfv6i.1wt/96b20693"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">City Cast Madison</h3>
        </a>
        <em>March 5, 2026</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-dec-25-to-31-2025/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>What to do in Madison this week</h2>
        </a>

        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-dec-25-to-31-2025/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>December 25, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://captimes.com/entertainment/5-fun-events-happening-in-madison-this-week-dec-24-31/article_f64e0dfc-2b02-4ebb-a572-0ecc14369270.html"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>5 fun events happening in Madison this week</h2>
        </a>

        <a
          href="https://captimes.com/entertainment/5-fun-events-happening-in-madison-this-week-dec-24-31/article_f64e0dfc-2b02-4ebb-a572-0ecc14369270.html"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">The Cap Times</h3>
        </a>
        <em>December 24, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/events/make-america-gay-again-nov-6/?occ_dtstart=2025-11-06T19:00"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks: Make America Gay Again</h2>
        </a>

        <a
          href="https://isthmus.com/events/make-america-gay-again-nov-6/?occ_dtstart=2025-11-06T19:00"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>November 6, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/events/a-very-roast-battle-halloween/?occ_dtstart=2025-10-25T20:00"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks: A Very Roast Battle Halloween</h2>
        </a>

        <a
          href="https://isthmus.com/events/a-very-roast-battle-halloween/?occ_dtstart=2025-10-25T20:00"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>October 25, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.wortfm.org/cheshire-cat-comedy-researching-the-silly-side-of-science/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Cheshire Cat Comedy: Researching the Silly Side of Science</h2>
        </a>

        <a
          href="https://www.wortfm.org/cheshire-cat-comedy-researching-the-silly-side-of-science/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">WORT.FM</h3>
        </a>
        <em>September 24, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/events/comedians-of-the-world-telling-jokes/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks - Comedians of the World Telling Jokes</h2>
        </a>

        <a
          href="https://isthmus.com/events/comedians-of-the-world-telling-jokes/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>July 5, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/events/make-america-gay-again-june-5/?occ_dtstart=2025-06-05T19:00"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks - Make America Gay Again</h2>
        </a>

        <a
          href="https://isthmus.com/events/make-america-gay-again-june-5/?occ_dtstart=2025-06-05T19:00"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>June 5, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://drinkswithdarin.substack.com/p/whats-tappening-get-your-groove-on"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>What's Tappening? - Get Your Groove On</h2>
        </a>

        <a
          href="https://drinkswithdarin.substack.com/p/whats-tappening-get-your-groove-on"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Drinks with Darin</h3>
        </a>
        <em>June 4, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-may-12-to-15-2025/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>What to do in Madison this week</h2>
        </a>

        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-may-12-to-15-2025/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>May 12, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.wortfm.org/a-horse-walks-into-a-bar/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>A Horse Walks Into A Bar</h2>
        </a>

        <a
          href="https://www.wortfm.org/a-horse-walks-into-a-bar/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">WORT.FM</h3>
        </a>
        <em>March 6, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.channel3000.com/madison-magazine/whats-so-funny/article_0431cccc-ced0-11ef-ac45-97b5b898236e.html"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>What's so funny?</h2>
        </a>

        <a
          href="https://www.channel3000.com/madison-magazine/whats-so-funny/article_0431cccc-ced0-11ef-ac45-97b5b898236e.html"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Madison Magazine</h3>
        </a>
        <em>January 15, 2025</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.wortfm.org/the-yucks-stop-here/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>The Yucks Stop Here</h2>
        </a>

        <a
          href="https://www.wortfm.org/the-yucks-stop-here/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">WORT.FM</h3>
        </a>
        <em>December 12, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/events/make-america-gay-again-nov-3/?occ_dtstart=2024-11-03T19:00"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks - Make America Gay Again</h2>
        </a>

        <a
          href="https://isthmus.com/events/make-america-gay-again-nov-3/?occ_dtstart=2024-11-03T19:00"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>November 3, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/events/comedy-roast-of-america/?occ_dtstart=2024-11-01T20:00"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks - Comedy Roast of America</h2>
        </a>

        <a
          href="https://isthmus.com/events/comedy-roast-of-america/?occ_dtstart=2024-11-01T20:00"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>November 1, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://captimes.com/entertainment/things-to-do-in-madison-comedy-roast-of-america-driftless-film-festival-hmong-new-year/article_e9f8490c-9609-11ef-af55-d7d04d4284cc.html"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Things to do in Madison - Comedy Roast of America</h2>
        </a>

        <a
          href="https://captimes.com/entertainment/things-to-do-in-madison-comedy-roast-of-america-driftless-film-festival-hmong-new-year/article_e9f8490c-9609-11ef-af55-d7d04d4284cc.html"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">The Cap Times</h3>
        </a>
        <em>October 30, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://captimes.com/entertainment/things-to-do-in-madison-jin-wen-yu-dance-art-walk-vegan-fest-and-more/article_f8df02d2-7a8c-11ef-8f4f-b3cfea11f458.html"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Things to do in Madison - THE SH!TSHOW</h2>
        </a>

        <a
          href="https://captimes.com/entertainment/things-to-do-in-madison-jin-wen-yu-dance-art-walk-vegan-fest-and-more/article_f8df02d2-7a8c-11ef-8f4f-b3cfea11f458.html"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">The Cap Times</h3>
        </a>
        <em>September 25, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.channel3000.com/madison-magazine/best-of-madison-2024-winners/article_c4a98312-71f8-11ef-bff3-4f27b483d3d8.html"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Best of Madison 2024</h2>
        </a>

        <a
          href="https://www.channel3000.com/madison-magazine/best-of-madison-2024-winners/article_c4a98312-71f8-11ef-bff3-4f27b483d3d8.html"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Madison Magazine</h3>
        </a>
        <em>September 19, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.wortfm.org/sasha-rosser-renaissance-woman/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Sasha Rosser, Renaissance Woman</h2>
        </a>

        <a
          href="https://www.wortfm.org/sasha-rosser-renaissance-woman/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">WORT.FM</h3>
        </a>
        <em>August 29, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.wisconsinsciencefest.org/event/words-with-nerds-spooky-edition/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>
            Words with Nerds featured at the 2024 Wisconsin Science Festival
          </h2>
        </a>

        <a
          href="https://www.wisconsinsciencefest.org/event/words-with-nerds-spooky-edition/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Wisconsin Science Festival</h3>
        </a>
        <em>August 12, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/events/beers-with-queers-june-28/?occ_dtstart=2024-06-28T21:30"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks - Beers with Queers</h2>
        </a>

        <a
          href="https://isthmus.com/events/beers-with-queers-june-28/?occ_dtstart=2024-06-28T21:30"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>June 28, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/events/comedy-roast-of-the-easter-bunny/?occ_dtstart=2024-03-30T21:00"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks - Comedy Roast of the Easter Bunny</h2>
        </a>

        <a
          href="https://isthmus.com/events/comedy-roast-of-the-easter-bunny/?occ_dtstart=2024-03-30T21:00"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>March 30, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://badgerherald.com/artsetc/2024/01/24/comedian-michael-meyer-to-bring-good-vibes-to-madison-this-weekend/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>
            Comedian Michael Meyers to bring “Good Vibes” to Madison this
            weekend
          </h2>
        </a>

        <a
          href="https://badgerherald.com/artsetc/2024/01/24/comedian-michael-meyer-to-bring-good-vibes-to-madison-this-weekend/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">The Badger Herald</h3>
        </a>
        <em>January 24, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-jan-4-to-7-2024/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks - Make America Gay Again</h2>
        </a>

        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-jan-4-to-7-2024/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>January 4, 2024</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.wortfm.org/looking-for-laughs-in-all-the-right-places/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Looking For Laughs In All The Right Places</h2>
        </a>

        <a
          href="https://www.wortfm.org/looking-for-laughs-in-all-the-right-places/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">WORT.FM</h3>
        </a>
        <em>December 8, 2023</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-nov-9-to-12-2023/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>
            Isthmus Picks - Overworked, Underpaid: The Teacher Comedy Tour{" "}
          </h2>
        </a>

        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-nov-9-to-12-2023/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>November 11, 2023</em>
      </div>
      <div className="press-entry">
        <a
          href="https://madison.com/life-entertainment/local/art-theater/madison-comedy-scene/article_1f898a32-7422-11ee-9235-1b9c205f80d2.html"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>
            Did you hear the one about the Wisconsin town with all the comedy
            shows?
          </h2>
        </a>

        <a
          href="https://madison.com/life-entertainment/local/art-theater/madison-comedy-scene/article_1f898a32-7422-11ee-9235-1b9c205f80d2.html"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Wisconsin State Journal</h3>
        </a>
        <em>October 30, 2023</em>
      </div>
      <div className="press-entry">
        <a
          href="https://soundcloud.com/wort-fm/comedy-that-purrs"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Comedy That Purrs</h2>
        </a>

        <a
          href="https://soundcloud.com/wort-fm/comedy-that-purrs"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">WORT.FM</h3>
        </a>
        <em>October 5, 2023</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.channel3000.com/madison-magazine/best-of-madison/best-of-madison-2023-winners/article_51b80be4-523c-11ee-8d38-4b0460d342e5.html"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Best of Madison 2023</h2>
        </a>

        <a
          href="https://www.channel3000.com/madison-magazine/best-of-madison/best-of-madison-2023-winners/article_51b80be4-523c-11ee-8d38-4b0460d342e5.html"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Madison Magazine</h3>
        </a>
        <em>September 14, 2023</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.wortfm.org/comedy-machine-at-breese-stevens-field/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Comedy Machine at Breese Stevens Field</h2>
        </a>

        <a
          href="https://www.wortfm.org/comedy-machine-at-breese-stevens-field/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">WORT.FM</h3>
        </a>
        <em>June 1, 2023</em>
      </div>
      <div className="press-entry">
        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-may-29-to-june-1-2023/"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Isthmus Picks - Make America Gay Again</h2>
        </a>

        <a
          href="https://isthmus.com/arts/isthmus-madison-picks-may-29-to-june-1-2023/"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Isthmus</h3>
        </a>
        <em>May 29, 2023</em>
      </div>
      <div className="press-entry">
        <a
          href="https://www.channel3000.com/news/local-news/local-comedians-host-benefit-show-for-ukraine-relief/article_46d33d0c-3e42-5c7e-96a1-ea1586c06a54.html"
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <h2>Local comedians host benefit show for Ukraine relief</h2>
        </a>

        <a
          href="https://www.channel3000.com/news/local-news/local-comedians-host-benefit-show-for-ukraine-relief/article_46d33d0c-3e42-5c7e-96a1-ea1586c06a54.html"
          target="_blank"
          rel="noreferrer"
          className="press-heading"
        >
          <h3 className="press-heading">Channel 3000</h3>
        </a>
        <em>April 10, 2022</em>
      </div>
    </div>
  );
}
